import { css } from 'emotion';

export const dialog = css`
  display: flex;
  flex-direction: column;

  > div:first-child {
    margin-bottom: 20px;
  }
`;
